<template>
  <div class="font-family-index" v-clickoutside:exactAreaClassName="handleUnCheck">
    <section class="ff-header selector" v-if="selector">
      <div class="ffh-01">
        <div class="ff-sec1 ff-top">
          <div class="c-search-box">
            <el-input
              v-model="fontParams.name"
              @keyup.enter.native="submitSearchFont"
              placeholder="搜索您要的字体"
            ></el-input>
            <el-button
              @click="submitSearchFont"
              type="primary"
              circle
              class="c-search-btn"
              ><i class="iconfont icon-search"></i
            ></el-button>
          </div>
          <!-- 这边去掉是因为！selector，弹出框里面没有上传字体 -->
          <!-- <font-uploader
            style="float: right"
            type="primary"
            :multiple="true"
            @onAdd="onAddFont"
            v-if="!selector"
          ></font-uploader>
          <font-uploader
            style="height: 0px; overflow: hidden"
            ref="singUploaderRef"
            type="primary"
            :autoSave="false"
            :multiple="false"
            @onAdd="onAddFontForUpdate"
            v-if="!selector"
          ></font-uploader> -->
        </div>
        <div class="tag-box ff-top">
          <div class="tags">
            <span
              class="tags-item"
              @click="toggleName(null)"
              :class="{ active: !fontParams.makers.length }"
              >全部</span
            >
            <span
              class="tags-item"
              v-for="item in nameList"
              :key="item"
              @click="toggleName(item)"
              :class="{ active: fontParams.makers.includes(item) }"
              >{{ item }}</span
            >
            <self-radio
              v-model="isAll"
              @onChange="onCheckAll"
              :disabled="fontList.length === 0"
              >全选</self-radio
            >
          </div>
        </div>
      </div>
    </section>
    <section class="ff-header" v-else>
      <div class="ffh-01">
        <p class="ff-title">{{ title }}</p>
        <div class="ff-sec1 ff-top">
          <div class="c-search-box">
            <el-input
              v-model="fontParams.name"
              @keyup.enter.native="submitSearchFont"
              placeholder="搜索您要的字体"
            ></el-input>
            <el-button
              @click="submitSearchFont"
              type="primary"
              circle
              class="c-search-btn"
              ><i class="iconfont icon-search"></i
            ></el-button>
          </div>
          <font-uploader-box style="float: right;" @onAdd="onFontUpload"></font-uploader-box>
          <!-- <font-uploader
            style="float: right"
            type="primary"
            :multiple="true"
            @onAdd="onAddFont"
            v-if="!selector"
          ></font-uploader>
          <font-uploader
            style="height: 0px; overflow: hidden"
            ref="singUploaderRef"
            type="primary"
            :autoSave="false"
            :multiple="false"
            @onAdd="onAddFontForUpdate"
            v-if="!selector"
          ></font-uploader> -->
        </div>
        <div class="tag-box ff-top">
          <div class="tags" v-if="!selector">
            <span class="name">字体库：</span>
            <span
              class="tags-item"
              @click="toggleSystemFont(null)"
              :class="{ active: fontParams.systemFont === null }"
              >全部</span
            >
            <!-- <template v-for="(item, index) in systemFontList"> -->
            <span
              v-for="(item, index) in systemFontList"
              class="tags-item"
              @click="toggleSystemFont(item)"
              :key="index"
              :class="{ active: fontParams.systemFont === item.value }"
              >{{ item.name }}</span
            >
            <!-- </template> -->
          </div>
          <div class="tags">
            <span class="name">名称：</span>
            <span
              class="tags-item"
              @click="toggleName(null)"
              :class="{ active: !fontParams.makers.length }"
              >全部</span
            >
            <span
              class="tags-item"
              v-for="item in nameList"
              :key="item"
              @click="toggleName(item)"
              :class="{ active: fontParams.makers.includes(item) }"
              >{{ item }}</span
            >
          </div>
          <div class="tags">
            <span class="name">类型：</span>
            <span
              class="tags-item"
              @click="toggleType(null)"
              :class="{ active: !fontParams.types.length }"
              >全部</span
            >
            <span
              class="tags-item"
              v-for="item in typeList"
              :key="item"
              @click="toggleType(item)"
              :class="{ active: fontParams.types.includes(item) }"
              >{{ item }}</span
            >
          </div>
          <div class="tags">
            <span class="name">适用语种：</span>
            <span
              class="tags-item"
              @click="toggleLanguage(null)"
              :class="{ active: !fontParams.languages.length }"
              >全部</span
            >
            <span
              class="tags-item"
              v-for="item in languageList"
              :key="'languageList' + item.value"
              :class="{ active: fontParams.languages.includes(item.name) }"
              @click="toggleLanguage(item.name)"
              >{{ item.name }}</span
            >
          </div>
        </div>
      </div>
      <div class="ffh-02">
        <div class="choose-tag" v-show="hasSelectedConditions">
          您已选择：
          <span class="ct-item" v-if="fontParams.systemFont !== null" key="-1"
            ><span v-text="formatter(fontParams.systemFont)"></span>
            <i
              class="el-icon-close del-tag"
              @click="deleteSystemFontTag(item)"
            ></i>
          </span>
          <span
            class="ct-item"
            v-for="(item, index) in conditionList"
            :key="index"
          >
            {{ item }}
            <i class="el-icon-close del-tag" @click="deleteTag(item)"></i>
          </span>
        </div>
        <div class="ff-tools">
          <self-radio
            v-model="isAll"
            @onChange="onCheckAll"
            :disabled="fontList.length === 0"
            >全选</self-radio
          >
          <template>
            <el-button
              size="mini"
              @click="onClassifyBatch"
              :disabled="checkedIds.length === 0"
              class="exactAreaClassName"
              >分类</el-button
            >
            <el-button
              size="mini"
              class="exactAreaClassName"
              @click="onDelAll"
              :disabled="checkedIds.length === 0"
              >删除</el-button
            >
          </template>
        </div>
      </div>
    </section>
    <div
      class="p-loading"
      v-if="pageLoading"
      v-loading="pageLoading"
      element-loading-text="拼命加载中, 请稍候"
      element-loading-spinner="el-icon-loading"
    ></div>
    <section v-if="fontList.length > 0" style="padding: 0 20px;">
      <ul class="font-family-ul">
        <li
          class="font-item exactAreaClassName"
          :class="{
            // 'active-info': fontInfoVisible && activeItem.id === item.id
						'active-info': !!item.checked,
            'hasIn': selector && item.addedToProj
          }"
          v-for="(item, index) in fontList"
          :key="item.id"
					@click.stop="toggleCheck(item)"
        >
					<div class="font-footer">
            <span class="fb-tools" v-if="edit(item)">
              <el-popover
                popper-class="no-arrow"
                placement="right-start"
                width="90"
                trigger="hover"
                visible-arrow="false"
              >
                <ul>
                  <li @click="showFontInfo(item)">字体信息</li>
                  <li @click="onClassify(item)">分类</li>
                  <!-- <li @click="onUpdate(item)">更新</li> -->
                  <li @click="onDel(item, index)">删除</li>
                </ul>
                <div class="item-menu" slot="reference" v-if="!selector">
                  <i class="el-icon-more"></i>
                </div>
              </el-popover>
            </span>
						<span class="item">
              {{ item.fontFamily }}<br/>
              <span>{{ item.weight }}</span>
            </span>
            <!-- <el-input
              :title="item.alias"
              class="item"
              :ref="'nameInput' + index"
              :disabled="!edit(item) || editId !== item.id"
              :autofocus="true"
              :maxlength="30"
              size="small"
              v-model="item.alias"
              @focus="onFocus(item)"
              @blur="onChange(item)"
              :class="{ edit: edit(item) && editId === item.id }"
            >
            </el-input> -->
          </div>
          <div class="font-body c-mask">
            <!-- <p class="fb-desc">
              <span class="fbd-icon c-f-left" v-if="item.canCommercial"
                >可商用</span
              >
              <span class="fbd-icon c-f-left" v-if="item.newestUpload"
                >新上传</span
              >
              <span class="fbd-icon c-f-left" v-else-if="item.recentUpload"
                >最近上传</span
              >
            </p> -->
            <div class="fb-title" :style="{ fontFamily: item.name }">
              <img :src="item.cover" v-if="item.cover" />
              <div v-else>
                <p class="cn-name">自助设计字体</p>
                <p class="en-name">ABCDEFG1234567890</p>
              </div>
              <!-- <div
                class="c-mask-cover"
                :class="item.checked ? 'active' : ''"
                @click="toggleCheck(item)"
              >
                <i
                  class="iconfont"
                  :class="
                    item.check
                      ? 'active icon-check-checked'
                      : 'icon-check-hover'
                  "
                ></i>
              </div> -->
							<!-- <div class="c-mask-cover" @click="toggleCheck(item)"></div> -->
            </div>
          </div>
        </li>
      </ul>
    </section>
    <no-result v-else-if="!pageLoading"></no-result>
    <el-dialog
      class="global-dialog"
      title="字体分类"
      width="550px"
      :visible.sync="classifyDialogVisible"
    >
      <el-form label-width="120px">
        <el-form-item label="字体名称：">
          <self-select
            style="width: 194px"
            v-model="classifyObj.maker"
            :multiple="false"
            ref="nameSelect"
          >
            <self-option value="" key="-1" @onClick="newName">
              <div slot="header">新建标签</div>
            </self-option>
            <self-option
              v-for="item in nameList"
              :key="item"
              :label="item"
              :value="item"
            >
            </self-option>
          </self-select>
        </el-form-item>
        <el-form-item label="类型：">
          <self-select
            style="width: 194px"
            v-model="classifyObj.type"
            :multiple="false"
            ref="typeSelect"
          >
            <self-option value="" key="-1" @onClick="newType">
              <div slot="header">新建标签</div>
            </self-option>
            <self-option
              v-for="item in typeList"
              :key="item"
              :label="item"
              :value="item"
            >
            </self-option>
          </self-select>
        </el-form-item>
        <el-form-item label="适用语种：">
          <el-select v-model="classifyObj.language" style="width: 194px">
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :value="item.value"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="可商用：">-->
        <!--<el-checkbox v-model="classifyObj.canCommercial"></el-checkbox>-->
        <!--</el-form-item>-->
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="confirmClassify">确定</el-button>
      </span>
    </el-dialog>
    <font-info-dialog
      v-if="!selector"
      v-model="fontInfoVisible"
      @onAliasChange="onAliasChange"
      @onMainNamesChange="onMainNamesChange"
      :data="activeItem"
    ></font-info-dialog>
  </div>
</template>
<script>
// import fontUploader from '../../template/font/font-uploader'
import fontUploaderBox from '@/views/template/font/font-uploader-box'
import noResult from '@/views/components/noResult'
import fontService from '../../../request/service/font-service'
import { platform_list, language_list } from '@/const.js'
import selfRadio from '@/views/components/radio/radio-index'
import util from '@/util'
import fontInfoDialog from './font-info-dialog'
const empty_item = { maker: null, type: null, language: null }
const empty_font_item = { id: null, mainNames: [] }
import Clickoutside from '@/plugins/v-clickoutside'
export default {
  components: { noResult, fontUploaderBox, selfRadio, fontInfoDialog },
  props: {
    title: { type: String, default: '公共字体库' },
    selector: { type: Boolean, default: false }, //作为弹框，用来选择字体
    systemFont: { type: Boolean, default: null },
    projectId: { type:String, default: null }
  },
  directives: {
    Clickoutside
  },
  data () {
    return {
      editId: null,
      fontName: '',
      nameTagList: [],
      typeTagList: [],
      chooseTagList: [],
      classifyDialogVisible: false,
      pageLoading: false,
      classifyObj: { ...empty_item },
      typeList: [],
      languageList: language_list,
      nameList: [],
      fontParams: {
        projectId: this.projectId,
        systemFont: null,
        languages: [],
        makers: [],
        platforms: [],
        types: [],
        name: ''
      },
      fontList: [],
      cacheMap: {},
      coverLoading: false,
      systemFontList: [
        { name: '公共字体', value: true },
        { name: '项目上传字体(未审核)', value: false }
      ],
      isAll: false,
      activeItem: JSON.parse(JSON.stringify(empty_font_item)),
      fontInfoVisible: false
    }
  },
  computed: {
    checkedIds () {
      let ids = []
      this.fontList.map(item => {
        if (item.checked) {
          ids.push(item.id)
        }
      })
      return ids
    },
    hasSelectedConditions () {
      let { systemFont, languages, makers, types } = this.fontParams
      return (
        systemFont !== null ||
        makers.length > 0 ||
        types.length > 0 ||
        languages.length > 0
      )
    },
    conditionList () {
      let { makers, types, languages } = this.fontParams
      return [...makers, ...types, ...languages]
    }
  },
  watch: {
    projectId (val) {
      this.fontParams.projectId = val
      this.getData()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.fontInfoVisible = false
    next()
  },
  created () {
    this.init()
    this.getMakerList()
    this.getTypeList()
  },
  methods: {
    init () {
      this.getData()
    },
    getData (addList) {
      this.pageLoading = true
      let params = JSON.parse(JSON.stringify(this.fontParams))
      if (this.selector) {
        params.systemFont = this.systemFont
      }
      params.languages = this.formatLanguage(params.languages)
      fontService
        .getFontList(params)
        .then(data => {
          data.forEach(item => {
            item.originName = item.name
          })
          this.fontList = data
          if (addList) {
            this.fontList.forEach(item => {
              if (addList.includes(item.id)) {
                // item.checked = true
                util.setVueAttr(this, item, 'checked', true)
              }
            })
          }
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    formatLanguage (languageList) {
      if (languageList && languageList.length > 0) {
        let map = {}
        this.languageList.forEach(item => {
          map[item.name] = item.value
        })
        languageList.forEach((name, idx) => {
          languageList[idx] = map[name]
        })
      }
      return languageList
    },
    showDesc (item) {
      let isEmpty = !item.language && !item.platform
      return (
        !(item.platform === 'UNDEFINED' && item.language === 'UNDEFINED') &&
        !isEmpty
      )
    },
    getMakerList () {
      fontService.getMakerList().then(data => {
        this.nameList = data
      })
    },
    getTypeList () {
      fontService.getTypeList().then(data => {
        this.typeList = data
      })
    },
    edit (item) {
      if (this.$store.getters['app/isSYSAdmin']) {
        return true
      }
      let loginUserId = this.$store.state.app.loginUser.id
      if (item.createdById === loginUserId) {
        return true
      }
      return false
    },
    // onFocus (item) {
    //   this.cacheItem = { ...item } //缓存刚点击的元素，如果更新报错，通过这个还原修改前的数据
    // },
    // onChange (item) {
    //   this.editId = null
    //   fontService
    //     .updateFont(item)
    //     .then(() => {
    //       this.getData()
    //     })
    //     .catch(() => {
    //       if (this.cacheItem) {
    //         Object.assign(item, this.cacheItem)
    //       }
    //     })
    // },
    deleteTag (item) {
      let makersIndex, typesIndex, languageIndex
      makersIndex = this.fontParams.makers.indexOf(item)
      typesIndex = this.fontParams.types.indexOf(item)
      languageIndex = this.fontParams.languages.indexOf(item)
      if (makersIndex >= 0) {
        this.fontParams.makers.splice(makersIndex, 1)
      }
      if (typesIndex >= 0) {
        this.fontParams.types.splice(typesIndex, 1)
      }
      if (languageIndex >= 0) {
        this.fontParams.languages.splice(typesIndex, 1)
      }
      this.submitSearchFont()
    },
    deleteSystemFontTag () {
      this.fontParams.systemFont = null
    },
    onEdit (item, index) {
      this.editId = item.id
      this.$nextTick(() => {
        this.$refs['nameInput' + index][0].focus()
      })
    },
    newType () {
      this.$refs.typeSelect.togglePopover(false)
      this.classifyObj.type = ''
    },
    newName () {
      this.$refs.nameSelect.togglePopover(false)
      this.classifyObj.maker = ''
    },
    onCopy (item) {},
    confirmClassify () {
      let cItem = this.classifyObj
      let checkedList = [cItem]
      if (this.isBatch) {
        checkedList = this.fontList.filter(item => {
          return item.checked
        })
        checkedList.forEach(item => {
          item.maker = cItem.maker || item.maker
          item.type = cItem.type || item.type
          item.language = cItem.language || item.language
        })
      }
      fontService
        .updateFont(checkedList)
        .then(() => {
          this.submitSearchFont()
          this.getMakerList()
          this.getTypeList()
          this.classifyDialogVisible = false
          this.classifyObj = {}
          this.$message.success('操作成功')
        })
        .catch(() => {
          if (this.cacheItem) {
            Object.assign(this.classifyObj, this.cacheItem)
          }
        })
    },
    onDel (item) {
      this.$confirm(`确定删除字体“${item.alias}”`, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.del([item.id])
        })
        .catch(() => {})
    },
    del (ids) {
      return fontService.delFont(ids).then(() => {
        this.fontList = this.fontList.filter(item => {
          return ids.indexOf(item.id) === -1
        })
        this.$message.success('删除成功')
        this.isAll = false
      })
    },
    submitSearchFont () {
      this.isAll = false
      this.getData()
    },
    toggleName (item) {
      if (!item) {
        this.fontParams.makers = []
      } else {
        let index = this.fontParams.makers.indexOf(item)
        if (index >= 0) {
          this.fontParams.makers.splice(index, 1)
        } else {
          this.fontParams.makers.push(item)
        }
      }
      this.submitSearchFont()
    },
    toggleType (value) {
      if (!value) {
        this.fontParams.types = []
      } else {
        let index = this.fontParams.types.indexOf(value)
        if (index > -1) {
          this.fontParams.types.splice(index, 1)
        } else {
          this.fontParams.types.push(value)
        }
      }
      this.submitSearchFont()
    },
    toggleLanguage (name) {
      if (!name) {
        this.fontParams.languages = []
      } else {
        let index = this.fontParams.languages.indexOf(name)
        if (index > -1) {
          this.fontParams.languages.splice(index, 1)
        } else {
          this.fontParams.languages.push(name)
        }
      }
      this.submitSearchFont()
    },
    onClickUpdateCover () {},
    onFontUpload (itemId) {
      this.getData([itemId])
      // if (type === 'add') {
      //   data.checked = true
      //   this.fontList.unshift(data)
      // } else {
      //   this.fontList = this.fontList.map(item => {
      //     if (item.id === data.id) {
      //       item.checked = true
      //       return data
      //     }
      //     return item
      //   })
      // }
    },
    formatter (systemFont) {
      return this.systemFontList.filter(item => {
        return item.value === systemFont
      })[0].name
    },
    toggleSystemFont (item) {
      this.fontParams.systemFont = item ? item.value : null
      this.submitSearchFont()
    },
    onCheckAll (val) {
      this.fontList.forEach(item => {
        util.setVueAttr(this, item, 'checked', val)
      })
      this.$emit('onChange', this.checkedIds)
    },
    toggleCheck (item) {
      if (this.selector && item.addedToProj) {
        return
      }
      let val = item.checked ? false : true
      util.setVueAttr(this, item, 'checked', val)
      this.$emit('onChange', this.checkedIds)
    },
    onDelAll () {
      this.$confirm('确定删除当前选中字体?', '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.del(this.checkedIds)
        })
        .catch(() => {})
    },
    onClassify (item) {
      this.isBatch = false
      this.classifyDialogVisible = true
      this.classifyObj = item
    },
    onClassifyBatch () {
      this.isBatch = true
      this.classifyDialogVisible = true
      this.classifyObj = { ...empty_item }
    },
    showFontInfo (item) {
      let toggle = item.id === this.activeItem.id ? false : true
      this.fontInfoVisible = toggle
      item.mainNames = item.mainNames ? item.mainNames : []
      this.activeItem = toggle
        ? JSON.parse(JSON.stringify(item))
        : JSON.parse(JSON.stringify(empty_font_item))
    },
    onAliasChange ({ id, alias }) {
      let idx = this.fontList.findIndex(item => {
        return item.id === id
      })
      this.fontList[idx].alias = alias
    },
    onMainNamesChange ({ id, mainNames }) {
      let idx = this.fontList.findIndex(item => {
        return item.id === id
      })
      this.fontList[idx].mainNames = mainNames
    },
    onUpdate (item) {
      this.$refs.singUploaderRef.$el.querySelector('button').click()
      this.currentFont = item
    },
    onAddFontForUpdate ({ url, cover, mainNameOnFile }) {
      this.currentFont.url = url
      this.currentFont.cover = cover
      this.currentFont.mainNameOnFile = mainNameOnFile
      fontService.updateFontUrl(this.currentFont).then(() => {
        this.$alert('上传成功')
      })
    },
    handleUnCheck (e) {
      if (this.selector) {
        return
      }
      this.isAll = false
      this.fontList.forEach(item => {
        util.setVueAttr(this, item, 'checked', false)
      })
    }
  }
}
</script>
<style lang="scss">
@import './font-system-index';
</style>
